export default __webpack_public_path__ + "static/media/videoJd4.8115ac1a.mp4";